<template>
  <div v-if="isLoading" class="dd-loader" style="position: relative">
    <spinner />
  </div>
  <div v-else-if="formsUrl" style="width: 100%">
    <iframe
      type="text/html"
      allow="clipboard-read; clipboard-write"
      :src="formsUrl"
      style="width: inherit; height: 100%"
    />
  </div>
  <div v-else class="forms-empty-state" style="width: 100%">
    <div class="forms-empty">
      <div>
        <img src="~dashboard/assets/images/lock.svg" alt="No Forms" />
        <span>
          {{ $t('FORMS.NO_FORMS') }}
          <br />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import formsAPI from 'dashboard/api/integrations/forms';
import Spinner from 'shared/components/Spinner.vue';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  components: { Spinner },
  mixins: [alertMixin],
  props: {
    accountId: [String, Number],
  },
  data() {
    return {
      formsUrl: null,
      isLoading: true,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.isLoading = true;
      try {
        const { data } = await formsAPI.getLoginLink();
        this.formsUrl = data?.url;
      } catch (error) {
        this.showAlert(this.$t('INTEGRATION_SETTINGS.API_ERROR_MESSAGE'));
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.forms-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    img {
      margin: var(--space-normal);
      width: 10rem;
    }

    span {
      font-size: var(--font-size-small);
      font-weight: var(--font-weight-medium);
      text-align: center;
    }
  }
}

.forms-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
</style>
